import { useQuery } from "@tanstack/react-query";
import { getKlaviyoLists } from "../../api/bKlaviyoApi";

export const useGetKlaviyoLists = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["klaviyo-lists", organisationId],
    queryFn: () => getKlaviyoLists(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
